import { Image, ImageViewer, Popover, Swiper } from "antd-mobile";
import TreeCard from "components/Tree/TreeCard";
import Certificate from "components/alert/Certificate";
import Share from "components/alert/Share";
import r, { api } from "modules/Request";
import { truncateString } from "modules/common";
import { replaceSizeWithString } from "modules/filter-api";
import moment from "moment";
import DataCenterFailure from "pages/CarbonNeutralityDisclosure/Failure/DataCenterFailure";
import producttypeicon from "pages/HomePage/images/producttype.png";
import productxhicon from "pages/HomePage/images/productxh.png";
import productzlicon from "pages/HomePage/images/productzl.png";
import productzqicon from "pages/HomePage/images/productzq.png";
import Header from "pages/commonBox/Header";
import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { businessTo } from "utils";
import blockchainicon from "./../HomePage/images/blockchain.png";
import rightarrrowicon from "./../HomePage/images/rightarrow.png";
import "./ProductDetail.scss";
import CollspseListStyle from "./card/CollspseListStyle";
import CollspseStyle from "./card/CollspseStyle";
import ColumnDom from "./chartList/ColumnDom";
import PieDom from "./chartList/PieDom";
import jd1icon from "./images/jd1.png";
import jd2icon from "./images/jd2.png";
import jd3icon from "./images/jd3.png";
import jd4icon from "./images/jd4.png";
import jd5icon from "./images/jd5.png";
import right_icon from "./images/right_icon.png";
import round1 from "./images/round1.png";
import round2 from "./images/round2.png";
import round3 from "./images/round3.png";
import round4 from "./images/round4.png";
import GF_LOGO from "./images/gf_logo.png";
import SL_LOGO from "./images/sl_logo.png";
import "./index.scss";
import transverterFn from "i18nData";

const jdimgLis = [jd1icon, jd2icon, jd3icon, jd4icon, jd5icon];
// const roundList = [{img:round1,type:1}, round2, round3, round4, round5];
const roundList = [
  { img: round1, type: 1 },
  { img: round2, type: 2 },
  { img: round3, type: 3 },
  { img: round4, type: 4 },
];

export default function DataCenter() {
  const history = useHistory();
  const [resAll, setResAll] = useState({});
  const imageViewerRef = useRef(0);

  const { id, type, failure, productType, lang = "zh" } = r.getQueryString(); // productType（1是减排）

  const [emissionimgListIdx, setEmissionImgListIdx] = useState(0);
  const [emissionimgList, setEmissionImgList] = useState([]);
  const [emissionimgListImg, setEmissionimgListImg] = useState(false);
  const [dataVal, setDataVal] = useState({});
  const [strAll, setStrAll] = useState({}); //写死的翻译数据
  const [visible, setVisible] = useState(false);

  const excludeIds = ["5yo4c9kh", "htutj0vu", "xwyyd8nu"];
  const hideblockchainIds = [
    "nszqq23s",
    "nszqq231",
    "nszqq232",
    "nszqq233",
    "nszqq234",
    "nszqq235",
    "nszqq236",
    "nszqq237",
    "nszqq238",
    "nszqq239",
  ];
  const excludeArr = [
    {
      ids: ["5yo4c9kh", "htutj0vu", "xwyyd8nu"],
      logo: GF_LOGO,
    },
    {
      ids: [
        "ywrlh9zz",
        "elzwn6tk",
        "smzrt6m7",
        "gs7iqbor",
        "kbt0f4cn",
        "hw6f4tkm",
        "arayb9vk",
        "jtywl0rb",
        "7ienvjlp",
        "wg406dxj",
        "axdl8cv1",
        "fcfwr8ap",
        "nszqq23s",
        "nszqq231",
        "nszqq232",
        "nszqq233",
        "nszqq234",
        "nszqq235",
        "nszqq236",
        "nszqq237",
        "nszqq238",
        "nszqq239",
      ],
      logo: SL_LOGO,
    },
  ];

  const getExcludedLogo = (id) => {
    for (const item of excludeArr) {
      if (item.ids.includes(id)) {
        return item.logo;
      }
    }
    return null;
  };

  const isExcluded = (id) => {
    return excludeArr.some((item) => item.ids.includes(id));
  };
  // 负数默认柱状图
  const isNullDom = (negativeFlag, thisVal, dom) => {
    if (negativeFlag) {
      return <ColumnDom negativeFlag={negativeFlag} dataList={thisVal} />;
    } else {
      return dom;
    }
  };
  /**
   * 微信分享
   */
  const weChatSharing = (data) => {
    const url = window.location.href;
    // eslint-disable-next-line no-undef
    wx?.ready(function () {
      //需在用户可能点击分享按钮前就先调用
      // eslint-disable-next-line no-undef
      wx?.updateAppMessageShareData({
        title: data?.entName, // 分享标题
        // title: data?.data?.entName, // 分享标题
        desc: "低碳产品碳足迹披露", // 分享描述
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: data.boxPicList?.[0], // 分享图标
        success: function () {
          // 设置成功
        },
        error: (err) => {
          console.log(err);
        },
      });

      // eslint-disable-next-line no-undef
      wx?.updateTimelineShareData({
        title: data?.entName, // 分享标题
        // title: data?.data?.entName, // 分享标题
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: data.boxPicList?.[0], // 分享图标
        success: function () {
          // 设置成功
        },
      });
    });
  };
  useEffect(() => {
    setStrAll(transverterFn(lang === "zh"));
  }, [lang, resAll]);

  const getPageList = async () => {
    let result;
    if (lang === "zh") {
      if (productType == "1") {
        result = await businessTo(r.get(`${api.GET_FILL_REVIEWBASE}${id}`));
      } else {
        result = await businessTo(r.get(`${api.GET_FILL_REVIEW}${id}`));
      }
    } else {
      result = await businessTo(
        r.get(`${api.DATA_CENTER_GET_FILL_REVIEW}${id}`)
      );
    }

    if (!result) return;
    // setResAll(result?.zhProductDetail);
    const zhProductDetail = result?.zhProductDetail;
    weChatSharing(zhProductDetail);
    setResAll(zhProductDetail);
    document.title = zhProductDetail?.productName || "";
    if (productType == "1" || productType == "0") {
      setEmissionImgList(zhProductDetail?.certificateImgSelf);
    } else {
      setEmissionImgList(zhProductDetail?.certificateImg);
    }
  };

  // 判断是否在微信环境
  function isWeixinBrowser() {
    const ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf("micromessenger") !== -1;
  }
  // 区块链弹窗
  const getDetails = async (id) => {
    const result = await r.get(`${api.DATA_CENTER_UPCHAIN_INFO}${id}`);
    if (result.status.code === "00000") {
      setDataVal(result?.data);
      setVisible(true);
    }
  };
  useEffect(() => {
    // weChatSharing();
    r.post(api.DATA_CENTER_VISIT_H5 + id);
    getPageList();
  }, []);
  if (resAll?.h5DiscloseStatus == "0") {
    return <DataCenterFailure />;
  }
  return (
    <div className="data_center_box">
      <Share lang={lang} />
      <ImageViewer.Multi
        ref={imageViewerRef}
        images={emissionimgList}
        visible={emissionimgListImg}
        defaultIndex={emissionimgListIdx}
        getContainer={() => document.body}
        onClose={() => {
          setEmissionimgListImg(false);
        }}
        onIndexChange={(i) => {
          console.log(emissionimgListIdx, i);
        }}
      />

      <div className="common_card_box_no_margin">
        <div
          className="app-content-box white_box border_radius_hide"
          style={{ padding: ".33rem .32rem" }}
        >
          {getExcludedLogo(id) ? (
            <Image
              className="gf-logo"
              fit="contain"
              src={getExcludedLogo(id)}
            />
          ) : (
            <div>
              <Header resAll={resAll} />
              {resAll?.carbonLogo && (
                <Image
                  className="carbonLogo"
                  fit="contain"
                  src={resAll?.carbonLogo}
                />
              )}
            </div>
          )}
        </div>
        <div className="green_swiper_bor">
          {resAll?.boxPicList?.length == 1 ? (
            <Image
              className="img"
              width="8.72rem"
              height="6.21rem"
              fit="contain"
              src={resAll?.boxPicList[0]}
            />
          ) : (
            <Swiper
              // autoplay
              // trackOffset={10}
              slideSize={80}
              style={{
                "--border-radius": "8px",
              }}
              loop
              defaultIndex={0}
              indicator={(total, current) => {
                if (total > 1) {
                  return (
                    <div className="customIndicator">{`${
                      current + 1
                    } / ${total}`}</div>
                  );
                }
              }}
            >
              {resAll?.boxPicList?.map((item, index) => {
                return (
                  <Swiper.Item key={index}>
                    <div className="swiper_box">
                      <Image height="7.13rem" fit="contain" src={item} />
                    </div>
                  </Swiper.Item>
                );
              })}
            </Swiper>
          )}
        </div>
        <div
          className="white_box border_radius_hide"
          style={{ padding: ".43rem .32rem" }}
        >
          <div
            className="detail_box_title font-bold"
            style={{ fontSize: ".64rem" }}
          >
            {resAll?.productName || "-"}
          </div>
          <div className="detail_box_tip">
            {/* 公司主体：浙江耀阳新材料科技有限公司 */}
            {strAll?.entName} {resAll?.entName || "-"}
          </div>
          {resAll?.labelContent && (
            <p className="label_msg">
              {resAll?.labelIcon && (
                <div className="img-box">
                  <Image
                    className="label_msg_icon"
                    fit="contain"
                    src={resAll?.labelIcon}
                  />
                </div>
              )}
              {resAll?.labelContent && (
                <>
                  {resAll?.labelContent?.length > 21 ? (
                    <Popover
                      trigger="click"
                      placement="top"
                      content={resAll?.labelContent}
                    >
                      <p className="text-ellipsis label_msg_text">
                        {resAll?.labelContent}
                      </p>
                    </Popover>
                  ) : (
                    <p className="text-ellipsis label_msg_text">
                      {resAll?.labelContent}
                    </p>
                  )}
                </>
              )}
            </p>
          )}
        </div>
      </div>
      <div className="common_product_info_box">
        <div className="product-title-box">
          <p className="title">{strAll?.ProductInformation}</p>
          {resAll?.productMoreFlag && (
            <div
              className="more-box"
              onClick={() => {
                if (productType == "1") {
                  history.push("/productDetail?id=" + id + "&productType=1");
                } else if (productType == "0") {
                  history.push("/productDetail?id=" + id + "&productType=0");
                } else {
                  history.push("/productDetail?id=" + id);
                }
              }}
            >
              <p>{strAll?.MORE}</p>
              <Image className="right_icon" fit="contain" src={right_icon} />
            </div>
          )}
        </div>
        <div className="white-item product-info-box">
          <div className="product-info-box-item">
            <img src={producttypeicon} alt="" />
            <div className="item-right">
              <p className="font-bold">{strAll?.productType2}</p>
              <p>{resAll?.productCategoryCodeName || "--"}</p>
            </div>
          </div>
          <div className="product-info-box-item">
            <img src={productxhicon} alt="" />
            <div className="item-right">
              <p className="font-bold">{strAll?.productModel}</p>
              <p>{resAll?.productModel || "--"}</p>
            </div>
          </div>
          <div className="product-info-box-item">
            <img src={productzqicon} alt="" />
            <div className="item-right">
              <p className="font-bold">{strAll?.productPeriod}</p>
              <p>{`${resAll?.fillTime?.[0] || ""} - ${
                resAll?.fillTime?.[1] || ""
              }`}</p>
            </div>
          </div>
          {resAll?.productBrief && (
            <div className="product-info-box-tip">
              <p className="font-bold">{strAll?.productionExplain}</p>
              <p>{resAll?.productBrief || ""}</p>
            </div>
          )}
        </div>
      </div>
      {resAll?.processPics?.length > 0 && (
        <div className="sprocessflow-box">
          <CollspseStyle>
            <h3 className="collspse_title">{strAll?.ProcessProcess}</h3>
            <div className="sprocessflow_swiper_bor">
              <p>{strAll?.manufacturingProcess}</p>
              {/* <Swiper> */}
              {resAll?.processPics?.map((item, index) => {
                return (
                  <Swiper.Item key={index}>
                    <div className="swiper_box">
                      <Image fit="contain" src={item.url} />
                    </div>
                  </Swiper.Item>
                );
              })}
              {/* </Swiper> */}
            </div>
          </CollspseStyle>
        </div>
      )}

      <div className="">
        <CollspseStyle>
          <h3 className="collspse_title">{strAll?.ProductCarbonFootprint}</h3>
          <div className="common_card_box_no_margin">
            <div className="card_gray_top">
              <div className="product-carbon-box">
                <div className="carbon-box-left">
                  <p>{strAll?.ProductCarbonFootprint}</p>
                  <p>{resAll?.featureUnit}</p>
                </div>
                <div className="product-carbonvalue-box">
                  <p className="value">{resAll?.carbon}</p>
                  <span>{resAll?.carbonUnit}</span>
                </div>
                <div className="bottom-box">
                  <p className="">
                    <span>{strAll?.SystemBoundary}：</span>
                    <span className="bound">{resAll?.bound}</span>
                  </p>
                  <p className="">
                    {strAll?.productPeriod}：
                    <span className="font-bold-500">
                      {`${resAll?.fillTime?.[0] || ""} - ${
                        resAll?.fillTime?.[1] || ""
                      }`}
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div
              className="common_card_box"
              style={{ paddingBottom: ".28rem" }}
            >
              <div className="product-bottom-box">
                {resAll?.stageSortList?.map((item, idx) => {
                  return (
                    <div key={idx} className="product-bottom-box-item">
                      <div className="item-left">
                        <img src={item?.iconUrl} alt="" />
                        <p style={{ width: "auto" }}>{item?.name || "-"}</p>
                      </div>
                      <div
                        className={`item-right ${
                          Number(item?.summaryValue) < 0 ? "item-right-red" : ""
                        }`}
                      >
                        <p>
                          {Number(item?.summaryValue?.toFixed(5)) || "-"}{" "}
                          <span className="font-small">
                            {item.carbonUnit || "kg CO₂e"}
                          </span>
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="charts_box">
                {isNullDom(
                  resAll?.negativeFlag,
                  resAll?.stageSortList,
                  <PieDom dataList={resAll?.stageSortList} />
                )}
              </div>
            </div>
            {productType !== "0" &&
              productType !== "1" &&
              !hideblockchainIds.includes(id) && (
                <div className="new_common_card_box product-Blockchain-box mt-43r">
                  <p className="f48r bold">
                    <img src={blockchainicon} alt="" />
                    {strAll?.BlockchainBasedEvidenceStorage}
                    {resAll?.certificateAddress && !isExcluded(id) && (
                      <span
                        className="detail_certificate_box"
                        onClick={() => {
                          getDetails(resAll?.certificateAddress.split("/")[6]);

                          // window.open(resAll?.certificateAddress)
                        }}
                      >
                        {strAll?.ViewCertificate}
                        <img
                          alt=""
                          style={{
                            width: ".32rem",
                            height: ".32rem",
                            verticalAlign: "middle",
                            marginTop: "-.05rem",
                            marginRight: 0,
                          }}
                          className="right_icon"
                          src={right_icon}
                        />
                      </span>
                    )}
                  </p>
                  <div className="hash-box">
                    <div className="detail_cz_box">
                      <p className="">
                        Hash：
                        {resAll?.certificateContent &&
                          truncateString(resAll?.certificateContent)}
                      </p>
                    </div>
                    {resAll?.certificateAddress && !isExcluded(id) && (
                      <div
                        className={
                          resAll?.certificateAddress
                            ? "jump-box"
                            : "jump-box btn_disabled"
                        }
                        onClick={() => {
                          // resAll?.certificateAddress && window.open(resAll?.certificateAddress)
                          if (resAll?.certificateAddress) {
                            getDetails(
                              resAll?.certificateAddress.split("/")[6]
                            );
                          }
                        }}
                      >
                        <img src={rightarrrowicon} alt="" />
                      </div>
                    )}
                  </div>
                </div>
              )}
          </div>
        </CollspseStyle>
      </div>

      {type != "brief" && (
        <div className="distribution-box">
          <CollspseStyle>
            <h3 className="collspse_title">{strAll?.ProductDistribution}</h3>
            {resAll?.cumulativeAnalyseVO?.children?.map((item, idx) => {
              return (
                <div key={idx} className="tree-box">
                  <CollspseListStyle>
                    <div className="">
                      <h3
                        className="collspse_title collspse_detail_title"
                        // style={{ color: colorList[idx].color }}
                      >
                        <img
                          className="img_list_style"
                          alt=""
                          src={item?.iconUrl}
                        />
                        {item?.name}
                      </h3>
                      <div className="collspse_detail_title_value_box">
                        <p>
                          碳排放：
                          <span
                            className="collspse_detail_title_value"
                            // style={{ color: colorList[idx].color }}
                          >
                            {Number(item?.summaryValueInt?.toFixed(5))}
                          </span>
                        </p>
                        <p className="ml-53r">
                          占比：
                          <span
                            className={`${
                              Number(item?.proportion) < 0
                                ? "collspse_detail_title_value_red"
                                : "collspse_detail_title_value"
                            }`}
                            // style={{ color: colorList[idx].color }}
                          >
                            {item?.proportion}%
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className="carbon_footprint_detail_card_box">
                      {item?.children?.length > 0 && <TreeCard data={item} />}
                    </div>
                  </CollspseListStyle>
                </div>
              );
            })}
          </CollspseStyle>
        </div>
      )}
      {emissionimgList?.length > 0 && (
        <div className="">
          <CollspseStyle>
            <h3 className="collspse_title">
              {strAll?.CarbonReductionCertificationEvaluation}
            </h3>
            <div
              className="green_swiper_bor emissionimgList_indicator"
              style={{ marginBottom: ".64rem" }}
            >
              <Swiper
                // trackOffset={10}
                // slideSize={80}
                style={{
                  "--border-radius": "8px",
                }}
                onIndexChange={(e) => {
                  console.log(e);
                  imageViewerRef.current.swipeTo(e);
                }}
                // indicator={(total, current) => imageViewerRef.current.swipeTo(current)}
                loop
                stuckAtBoundary={false}
                indicator={(total, current) => {
                  if (total > 1) {
                    return (
                      <div className="customIndicator">{`${
                        current + 1
                      } / ${total}`}</div>
                    );
                  }
                }}
              >
                {emissionimgList?.map((item, index) => {
                  return (
                    <Swiper.Item key={index}>
                      <div
                        key={index}
                        className="emissionimgList_img_box"
                        onClick={() => {
                          setEmissionimgListImg(true);
                        }}
                      >
                        <Image height="7.13rem" fit="contain" src={item} />
                      </div>
                    </Swiper.Item>
                  );
                })}
              </Swiper>
              {/*  <div className="emissionimgList_box">
                <div
                  className="emissionimgList"
                  style={{ width: emissionimgList.length * 6.56 + 2 + "rem" }}
                >

                </div>
              </div> */}
              {resAll?.certificateLink && (
                <div
                  className="more_btn"
                  onClick={() => {
                    window.open(resAll?.certificateLink);
                  }}
                >
                  证书由 {resAll?.certificateOrgName} 颁发，查看详情
                  <span className="image-container">
                    {/* <Image className="right_icon" fit="contain" src={right_icon} /> */}
                    {">"}
                  </span>
                </div>
              )}
            </div>
          </CollspseStyle>
        </div>
      )}
      <div className="tempLcaRemark">
        <CollspseStyle>
          <h3 className="collspse_title">
            {strAll?.CarbonFootprintAccountingCriteria}
          </h3>
          <div className="bg-icon-box">
            <div className="new_common_card_box">
              <p className="font-bold">{strAll?.ReportingCriteriaReferenced}</p>
              {resAll?.referenceReportList && (
                <span className="referenceReportList">
                  {resAll?.referenceReportList?.map((item) => {
                    return <div className="mt-8">{item}</div>;
                  })}

                  {/* {resAll?.referenceReportList?.[0] && <div className="mt-8">{resAll?.referenceReportList?.[0]}</div>}
                  {resAll?.referenceReportList?.[1] && <div className="mt-53r">{resAll?.referenceReportList?.[1]}</div>}
                  {resAll?.referenceReportList?.[2] && <div className="mt-53r">{resAll?.referenceReportList?.[2]}</div>} */}
                </span>
              )}
              {resAll?.tempLcaRemark && (
                <>
                  <p className="mt-53r font-bold">
                    {strAll?.SystemBoundaryDescription}
                  </p>
                  <p className="referenceReportList">{resAll?.tempLcaRemark}</p>
                </>
              )}
            </div>
          </div>

          {/* {resAll?.tempLcaUrl && (
            <div className="new_common_card_box">
              <p className="">系统边界图</p>
              <Image className="tempLcaUrl mt-8" fit="cover" src={resAll?.tempLcaUrl} />
            </div>
          )} */}
        </CollspseStyle>
      </div>
      {(resAll?.entProfile || resAll?.footLogo) && (
        <div className="about_box">
          {resAll?.entProfile && (
            <div className="data_center_about">
              <div className="data_center_about_margin">
                <p className="data_center_about_title">{strAll?.AboutTitle}</p>
                <p
                  dangerouslySetInnerHTML={{
                    __html: replaceSizeWithString(resAll.entProfile),
                  }}
                  className="data_center_about_value"
                ></p>
              </div>
            </div>
          )}
          {isExcluded(id) ? (
            <Image
              className="data_center_logo"
              fit="contain"
              src={getExcludedLogo(id)}
            />
          ) : (
            resAll?.footLogo && (
              <div className="data_center_logo">
                <Image src={resAll?.footLogo} />
              </div>
            )
          )}
        </div>
      )}
      <Certificate
        visible={visible}
        setVisible={setVisible}
        list={{
          certificateContent: dataVal?.hashCode,
          certificateAddress: dataVal?.txid,
          blockHeight: dataVal?.blockNumber,
          certificateTime: moment(dataVal?.submitTime).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
          certificateSubjects: dataVal?.entName,
          geoLocation: dataVal?.businessAddress,
          hashname: "存证哈希",
          addressname: "链上交易ID",
        }}
      />
    </div>
  );
}
